module.exports = __webpack_public_path__ + "img/77330.1a96d57a.svg";